import React, { useState } from 'react';
import { Collapse, Icon } from 'antd';
// import style from './Section.module.sass';
import { useDrop, useDrag } from 'react-dnd';
import ItemTypes from '../ItemTypes';
import Card from '../Card';
import { useSelector, useDispatch } from 'react-redux';
import { findIdSelector } from '../reduxSelector';
import { useParams } from 'react-router';
import { generateId, generateSectionalIds, resetLayoutProperties, mergeAssetFieldWithFormField } from '../../../../../../helpers/commonFunction'
import { PUSH_ACTION_STACK } from '../../../../../../stateManager/store/formCreation/types';
import { addFormJson, addRemoveOnDragComplete, removeComponentFromJson } from '../../../../../../stateManager/store/formCreation/action';
import { addAssetJson } from '../../../../../../stateManager/store/assets/action';
import { IProps } from './component';
import { getRandomId } from "../../../../../../utils/random-id";
import { useEffect } from 'react';
import { fCardSelect } from '../../../../../../helpers/RxServices';
import _ from 'lodash';

const { Panel } = Collapse;

const Section = (props: IProps) => {
    const {
        json,
    } = props;
    const dispatch = useDispatch();
    const params: any = useParams();
    const { list: assets } = useSelector((state: any) => state.assets);
    const assetEditMode = useSelector((state: any) => state.assets.assetEditMode);
    const selectedAssetId = useSelector((state: any) => state.assets.selectedAssetId);
    // const forms = useSelector((state: any) => state.formcreation);
    // const form = forms[params.formId];
    // const { id } = props; // this will give the form id;
    const [visibility, setVisibility] = useState(true);
    const stateCards = useSelector(state => findIdSelector(state, params.formId, props.id.split("#")));
    let cards: any[] = [];
    if (json.isAsset || (assetEditMode && selectedAssetId)) {
        cards = json.fields || [];
    } else {
        cards = stateCards;
    }
    const cardContainer = useSelector(state => {
        const cardIdSplit = props.id.split('#');
        cardIdSplit.pop()
        return findIdSelector(state, params.formId, cardIdSplit, true)
    })

    const [, drag] = useDrag({
        item: { type: ItemTypes.CARD, id: props.id, json: props.json },
        end: (draggedItem: any, monitor) => {
            if (monitor.didDrop()) {

                const deleteData: any = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(cardContainer)),
                    itemId: draggedItem.id
                }

                const undoDeleteData: any = {
                    formid: params.formId,
                    droppedContainer: { json: JSON.parse(JSON.stringify(cardContainer)) },
                    draggedItem: JSON.parse(JSON.stringify(draggedItem))
                }

                const { isDragComplete, addData, undoAddData } = monitor.getDropResult()

                isDragComplete && dispatch({
                    type: PUSH_ACTION_STACK,
                    data: {
                        undo: () => {
                            dispatch(addRemoveOnDragComplete(undoAddData, undoDeleteData, true))
                        },
                        redo: () => {
                            dispatch(addRemoveOnDragComplete(deleteData, addData))
                        }
                    }
                })

                isDragComplete && dispatch(addRemoveOnDragComplete(
                    deleteData,
                    addData
                ))
            }
        }
    })

    const [{ isOver, canDrop }, drop] = useDrop({
        accept: [ItemTypes.BOX, ItemTypes.CARD],
        drop: (item: any, monitor) => {
            if (item.type === ItemTypes.BOX && !monitor.didDrop() && item.isAsset) {
                // Check if dropped-item is an asset
                let newItem: any;
                const newId: string = generateId(item, { json: props.json });
                const assetInstanceId = getRandomId()

                if (item.json && item.json.fields && item.json.fields.length > 0) {
                    newItem = generateSectionalIds(item, newId)
                } else {
                    newItem = JSON.parse(JSON.stringify(item.json))
                    newItem.id = newId
                }
                newItem.assetInstanceId = assetInstanceId
                newItem.assetBindPrefix = getRandomId()

                // Reset layout properties when dropped into a non-layout section
                resetLayoutProperties(props.json, item.json, newItem)

                // const addData = {
                //     formid: params.formId,
                //     droppedContainer: { json: JSON.parse(JSON.stringify(props.json)) },
                //     draggedItem: newItem
                // }

                const undoAddData = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                    itemId: newId
                }
                //Generate a new ID for the dropped element
                //  const idArray = (cards.length > 0) && cards.map((el: any) => {
                //     return parseInt(el.id.split('-')[el.id.split('-').length - 1])
                // })

                // const idIncrement = (idArray.length > 0) ? Math.max(...idArray) + 1 : 0
                const generatedId = newId
                // const elementId = getRandomId();
                const componentId = getRandomId();

                dispatch({
                    type: PUSH_ACTION_STACK,
                    data: {
                        undo: () => {
                            dispatch(undoAddData)
                        },
                        redo: () => {
                            dispatch(addFormJson({ formId: params.formId, data: { ...item.json, label: item.label, id: generatedId } }))
                        }
                    }
                })

                dispatch(addFormJson({ formId: params.formId, data: { ...newItem, componentId } }))
                // return { isDragComplete: true, addData, undoAddData }
            } else if (item.type === ItemTypes.BOX && !monitor.didDrop()) {
                let propertyJson: any = {};
                let windows: any = window;
                let itemConfig: any;
                if (item.json && item.json?.widgetName) {
                    itemConfig = windows[item.json.type].data.widgets[item.json.widgetName]
                    if (itemConfig.config) {
                        for (let key in itemConfig.config) {
                            if (itemConfig.config[key].section === "properties" || itemConfig.config[key].section === "validate" || itemConfig.config[key].section === "data") {
                                propertyJson = {
                                    ...propertyJson, [key]: {
                                        id: item.id,
                                        [key]: itemConfig.config[key].default
                                    }
                                }
                            }
                            _.merge(item.json.properties, propertyJson[key])
                        }
                    }
                }

                //Generate a new ID for the dropped element
                const idArray = (cards && (cards.length > 0) && cards.map((el: any) => {
                    return parseInt(el.id.split('-')[el.id.split('-').length - 1])
                })) || [];

                const idIncrement = (idArray.length > 0) ? Math.max(...idArray) + 1 : 0
                const generatedId = props.id + "#" + item.id + "-" + idIncrement
                const elementId = getRandomId();
                const componentId = getRandomId();

                if (assetEditMode && selectedAssetId) {
                    dispatch(
                        addAssetJson({
                            data: {
                                ...item.json,
                                label: item.label,
                                id: generatedId,
                                elementId,
                                componentId,
                                isAsset: true,
                                assetId: selectedAssetId,
                                editBind: true,
                            },
                        })
                    );
                } else {
                    dispatch({
                        type: PUSH_ACTION_STACK,
                        data: {
                            undo: () => {
                                dispatch(removeComponentFromJson({
                                    formid: params.formId,
                                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                                    itemId: generatedId
                                }))
                            },
                            redo: () => {
                                dispatch(addFormJson({ formId: params.formId, data: { ...item.json, label: item.label, id: generatedId, elementId } }))
                            }
                        }
                    })
                    dispatch(addFormJson({ formId: params.formId, data: { ...item.json, label: item.label, id: generatedId, elementId, componentId } }))
                }

            } else if ((item.type === ItemTypes.CARD) && !monitor.didDrop()) {
                let newItem: any = {};
                const newId: string = generateId(item, { json: props.json });
                const componentId = getRandomId();

                newItem.componentId = componentId;
                if (item.json && item.json.fields && item.json.fields.length > 0) {
                    newItem = generateSectionalIds(item, newId)
                } else {
                    newItem = JSON.parse(JSON.stringify(item.json))
                    newItem.id = newId
                }

                // Reset layout properties when dropped into a non-layout section
                resetLayoutProperties(props.json, item.json, newItem)

                const addData = {
                    formid: params.formId,
                    droppedContainer: { json: JSON.parse(JSON.stringify(props.json)) },
                    draggedItem: newItem
                }

                const undoAddData = {
                    formid: params.formId,
                    draggedItemContainer: JSON.parse(JSON.stringify(props.json)),
                    itemId: newId
                }

                return { isDragComplete: true, addData, undoAddData }
            }
        },
        canDrop: (item) => {
            if (props.json && props.json.isAsset && !assetEditMode) {
                return false
            } else if (item.type !== ItemTypes.BOX && item.json.isChildAsset && !assetEditMode) {
                return false
            } else if (assetEditMode && props.json.assetId !== selectedAssetId) {
                return false
            } else if (item.type === ItemTypes.BOX) {
                return true
            } else if (item.type === ItemTypes.SECTION || item.type === ItemTypes.CARD) {
                if (item.id.startsWith(props.id)) {
                    //Prevents drops happening within the same container
                    if ((item.id.split('#').length - props.id.split('#').length) > 1) {
                        return true
                    }
                    return false
                } else if (props.id.startsWith(item.id)) {
                    // Prevents parent section dropping within their own child sections
                    return false
                }
                return true
            }
            return false
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            isOverCurrent: monitor.isOver({ shallow: true }),
            canDrop: monitor.canDrop()
        })
    })

    const isActive = isOver && canDrop;

    // const findCard = (id: string) => {
    //     const card = (cards).filter((c: any) => `${c.id}` === id.toString())[0]
    //     return {
    //         card,
    //         index: findIndex(cards, card),
    //     }
    // }

    // const moveCard = (
    //     (id: string, atIndex: number) => {
    //         const { card, index } = findCard(id);
    //         if (card) {
    //             let Localcards = (cards);
    //             Localcards.splice(index, 1);
    //             Localcards.splice(atIndex, 0, card)
    //         }

    //     }
    // )

    useEffect(() => {
        fCardSelect.getMessage().subscribe((res: any) => {
            if (res.id) {
                const { id, json: { selectedSection } } = res;
                if (props.id.includes(selectedSection)) {
                    setVisibility(true);
                } else {
                    const isTab = id.split("#").length > 1 ? false : true;
                    if (isTab) {
                        setVisibility(true);
                    } else {
                        // setVisibility(false);
                    }
                }
            }
        })
        // esint-disable-next-line
    }, [props.id])

    const getAssetField = (field: any) => {
        const aId = field?.assetId

        if (aId && assets[aId] && assets[aId].json && field.elementId === assets[aId].json.elementId) {
            const assetCopy = JSON.parse(JSON.stringify(assets[aId].json))
            const fieldCopy = JSON.parse(JSON.stringify(field))
            return mergeAssetFieldWithFormField(assetCopy, fieldCopy)
        }

        return field
    }

    const defaultCollapsed = (props.json && props.json.properties && props.json.properties.defaultCollapse)
    const collapsable = ((props.json && props.json.properties && props.json.properties.collapsable === false) ? false : true)

    return (
        <>
            {visibility &&
                <Collapse defaultActiveKey={defaultCollapsed ? ['0'] : ['1']}
                    className='override-form-section override-border-radius'
                    bordered={false}
                    expandIconPosition={"right"}
                    expandIcon={collapsable ? undefined : () => null}
                >
                    <Panel
                        header={
                            <div className='sectionLabel'>
                                {((props.json && props.json.isAsset) && !assetEditMode) && <Icon type="crown" />}
                                {(props.json && props.json.properties && props.json.properties.label) || 'Section'}
                            </div>
                        }
                        data-test-id="section_header"
                        className={"sectionHeader"}
                        key="1"
                    >
                        <div className="row"
                            ref={(ref) => drag(drop(ref))}
                            style={{ border: "3px dashed", borderColor: isActive ? "#c5e1a5" : canDrop ? "pink" : "white", height: '100%', display: 'flex', padding: '0 15px 15px 15px', minHeight: (cards && cards.length > 0) ? '0px' : '100px' }}>

                            {cards && cards.map((res: any) => {
                                const updatedRes = getAssetField(res)
                                return (<Card data-test-id={`card_${updatedRes.label}`} key={updatedRes.id} id={updatedRes.id}
                                    canEdit={props.canEdit}
                                    name={updatedRes.type}
                                    JsonData={updatedRes}
                                />)
                            })}

                        </div>
                    </Panel>
                </Collapse>}
        </>
    )
}

export default Section;
